import { api } from './api';

// Базируется на socialmatrix-api router + rn apiService

export const userService = {
  getCurrentUser: async () => {
    const { data } = await api.get('/user');
    return data;
  },

  getAllUsers: async () => {
    const { data } = await api.get('/users/all');
    return data;
  },

  getAllUsersForAdmin: async (params = {}) => {
    const { data } = await api.get('/users/all/admin', { params });
    return data;
  },

  getUsersFilteredForAdmin: async (filters = {}) => {
    const { data } = await api.get('/users/all/admin', { params: filters });
    return data;
  },

  getUserLogs: async (userId) => {
    const { data } = await api.get(`/admin/users/${userId}/logs`);
    return data;
  },

  saveUserNote: async (userId, note) => {
    const { data } = await api.post(`/admin/users/${userId}/note`, { note });
    return data;
  },

  getDeletedUsers: async () => {
    const { data } = await api.get('/users/deleted');
    return data;
  },

  getUsersFiltered: async (filter, language = 'ru') => {
    const filterParam = filter ? JSON.stringify(filter) : 'null';
    const { data } = await api.get(`/users/filtered/${filterParam}`, {
      params: { language },
    });
    return data;
  },

  getUsersByLogin: async (login, filter = null) => {
    const { data } = await api.post('/users/get-by-login', { login, filter });
    return data;
  },

  getUserById: async (id) => {
    const { data } = await api.get(`/user/${id}`);
    return data;
  },

  getUserByIdAdmin: async (id) => {
    const { data } = await api.get(`/userAmdin/${id}`);
    return data;
  },

  blockUser: async ({ userId }) => {
    const { data } = await api.post(`/admin/users/${userId}/block`);
    return data;
  },

  unblockUser: async ({ userId }) => {
    const { data } = await api.post(`/admin/users/${userId}/unblock`);
    return data;
  },

  deleteUser: async (userId) => {
    const { data } = await api.post(`/admin/users/${userId}/delete-account`);
    return data;
  },

  restoreUser: async (userId) => {
    const { data } = await api.post(`/admin/users/${userId}/restore-account`);
    return data;
  },

  deleteUserPhoto: async (userId, name) => {
    const { data } = await api.post(`/admin/users/${userId}/photo/delete`, { name });
    return data;
  },

  getHistoryActions: async (userId) => {
    const { data } = await api.get(`/admin/history-actions/${userId}`);
    return data;
  },

  getUserChats: async (userId) => {
    const { data } = await api.get(`/admin/users/${userId}/chats`);
    return data;
  },

  getChatMessagesAdmin: async (chatId) => {
    const { data } = await api.get(`/admin/chats/${chatId}/messages`);
    return data;
  },

  getUserByChatIdAdmin: async (chatId) => {
    const { data } = await api.get(`/admin/users/by-chat-id/${chatId}`);
    return data;
  },

  updateUser: async (userUpdate) => {
    const { data } = await api.post('/user/update', { userUpdate });
    return data;
  },
};

